module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/afgIc/tc-custom/9781439670613.jpg?1705025918121",
      "alt": "This image is the cover for the book Colorado’s Daring Ivy Baldwin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Colorado’s Daring Ivy Baldwin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At the beginning of the twentieth century, aerialist Ivy Baldwin had achieved celebrity status as a premier tightrope walker, aeronaut and aviation pioneer. He executed astonishing and perilous performances across America and internationally, including Mexico and the Far East. First by flying balloons, he went on to pilot dirigibles and, finally, aircraft. In his later years in Colorado, he became famous for crossing canyons on a tightrope. Historian Jack Stokes Ballard deftly captures Baldwin's colorful and hazardous life from childhood runaway to aviation record holder.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Jack Stokes Ballard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jack Stokes Ballard holds a Doctorate of Philosophy in American history from UCLA, taught history at the Air Force Academy and AFROTC at Occidental College, served a career in the U.S. Air Force and retired as chief of the Plans and Requirements Division at Lowry Air Force Base. He worked for the Martin Marietta Corporation for twelve years. He is the author of eight books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0